<template>
  <form id="form" v-loading="loading"  role="form" @submit.prevent="onFormSubmit">
    <span class="">Agregar monto</span>
      <div class="row">
        <div class="col-md-2 text-right align-self-center">
          
        </div>
        <div class="col-md-8 align-self-left">
          
          <money 
            v-bind="money"
            v-model="formData.ammount"
            class="el-input__inner input-with-select"
            >
          </money>
          <el-button icon="el-icon-circle-plus" native-type="submit"></el-button>
        </div>
        <div class="col-md-2 text-left align-self-center">
        </div>
      </div>
      <br><br>
      <div class="row">
        <div class="col-md-2 text-right align-self-center">
          
        </div>
        <div class="col-md-8">
          <el-table
              v-loading="loading"
              ref="table"
              :data="tableData"
              style="width: 100%"
              @row-click="handleRowClick"
              >
              <el-table-column
                  label="Mínimo"
                  align="center"
                  width="80"
                  >
                  <template slot-scope="scope">
                    <i  class="el-icon-success success" style="font-size: 24px !important; color: green;" v-if="scope.row.is_minimal"></i>
                  </template>
              </el-table-column>
              <el-table-column
                  label="Monto"
                  align="center"
                  header-align="center"
                  >
                  <template slot-scope="scope">{{ scope.row.ammount | currency}}</template>
              </el-table-column>
              <el-table-column
                  label=""
                  width="80"
                  align="center"
                  header-align="right">
                  <template slot-scope="scope">
                    <el-button  size="small" @click="deleteAmmount(scope.row)" icon="el-icon-delete" type="danger" round>
                    </el-button>
                  </template>
              </el-table-column>
          </el-table>
        </div>

        <div class="col-md-2">
          
        </div>
      </div>
  </form>
</template>
<script>
import { Card, FormGroupInput, Alert } from '@/components';
import { Table, TableColumn, MessageBox, Message, Input, Button, Badge } from 'element-ui';
import Settings from '@/providers/Settings'
import _ from 'lodash'
import {Money} from 'v-money'

const provider = new Settings()

export default {
  components: {
    Card,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    Alert,
    [Input.name]: Input,
    [Badge.name]: Badge,
    Money
  },
  props: [
    'projectId',
    'tableData'
  ],
  directives: {
  },
  data: () => ({
      formData: {
        ammount: 0,
        order: 0
      },
      loading: false,
      classValidation: '',
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '$ ',
        precision: 2,
        masked: false
      }
  }),
  methods: {
    onFormSubmit () {
      if(!this.formData.ammount && this.formData.ammount == 0) {
        // this.classValidation = "has-danger"
      } else{
        // this.classValidation = "has-success"
        let ammount = {
            ammount: this.formData.ammount,
            is_minimal: false,
            deleted: false
        }
        this.tableData.push(ammount)
        this.formData.ammount = 0
        this.$emit('changed', this.tableData)
      }
    },
    deleteAmmount(obj) {
      this.tableData.splice(obj, 1)
      this.$emit('changed', this.tableData)
    },
    handleRowClick(row, column, event) {
       _.each(this.tableData, (t)=> {
         t.is_minimal = false
         if (t == row) {
            t.is_minimal = true
         }
       })
    }
  }
};
</script>
<style lang="scss" scoped>
  .v-money {
    width: 250px;
  }
</style>
